import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { PersonAuthorityDrawer } from './PersonAuthorityDrawer';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/claims-authority/people/edit/$userId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit authority',
        },
    },
    params: {
        parse({ userId }) {
            return {
                userId: BigInt(userId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <PersonAuthorityDrawer userId={Route.useParams().userId} />
        </PageController>
    );
}
